import { createFileRoute } from "@tanstack/react-router";
import AIResearcher from "@/components/ai-consumer-research/ai-researcher/ai-researcher";

export const Route = createFileRoute("/dashboard/consumer-research/_layout/ai-researcher")({
  component: RouteComponent,
});

function RouteComponent() {
  return <AIResearcher />;
}
